// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationList_container__3tgLo","list":"NotificationList_list__1qd5S"};